import useFeatureFlags from 'app/hooks/useFeatureFlags';

import { RootLayout } from './RootLayout';

export function ArticlePageLayout() {
  const { uiRefreshIsiOnArticlePages } = useFeatureFlags();

  return <RootLayout hideImportantInformation={!uiRefreshIsiOnArticlePages} />;
}
